export default __webpack_public_path__ + "static/media/uv22_kr_head_a1.ae88f7d2.mp3";